import { Input, Label } from "@fluentui/react-components";
import { ArrowCircleLeftRegular } from "@fluentui/react-icons";
import * as React from "react";


function ReviewContract(props){
  console.log(props)
    const [fromFields, setFromFields] = React.useState({});

    function handleOnChange(event, item) {
        setFromFields((prev) => {
          const temp = { ...prev };
          temp[item] = event.target.value;
          return temp;
        });
      }

    return(

        <>
           {/* <div className="BackButtonContainer">
        <ArrowCircleLeftRegular onClick={()=>props.setisReviewContract(false)}/>
        </div> */}
        <div className="formFieldSection">
          <Label>{"Counterparty Name"}</Label>
          <Input aria-label={"Counterparty Name"} onChange={(event) => handleOnChange(event, "CounterpartyName")} />
        </div>
        <div className="formFieldSection">
          <Label>{"Adhoc Request"}</Label>
          <Input aria-label={"Adhoc Request"} onChange={(event) => handleOnChange(event, "AdhocRequest")} />
        </div>
        
        </>
    )
}

export default ReviewContract;